import React from 'react';
import {HeaderMenuItem, Menu, SubMenuItem} from 'components/Menu';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import {useTranslation} from 'react-i18next';
import {transportDataGetterContext} from './transportDataGetterContext';
import {action} from 'redux/helpers';
import {keySelectors, keyTypes} from 'redux/keys';
// import {directoryListingContext} from './DirectoryListingProvider';
import {useDispatch, useSelector} from 'react-redux';
import {IDiplomatFile} from 'types/DiplomatFile';
import {isUndefined} from 'lodash';
import {LoaderInline} from 'components/Loader';
import {useDialogContext} from 'common/context/DialogContext';
import {Tooltip} from '@mui/material';

export const ImportRemoteMenu = ({
   path,
   selected,
   listing,
   onUpdate,
}: {
   selected?: string;
   path?: string;
   listing: IDiplomatFile[];
   onUpdate: () => void;
}) => {
   const {t} = useTranslation();
   const dispatch = useDispatch();

   const isFetching = useSelector(keySelectors.isFetching);
   const {getTransportData, partnerId} = React.useContext(transportDataGetterContext);
   // console.debug('context', selected);

   const isDir = listing.find((o) => o.path === selected)?.directory;
   const isSelectedFile = selected && !isUndefined(isDir) && !isDir;
   const {loading, setLoading} = useDialogContext();
   // const isAdmin = useSelector(loginSelectors.isAdmin);

   return (
      <Menu
         name={
            isFetching ? (
               <LoaderInline />
            ) : (
               <Tooltip title={t('Import or Export Keys In This Location') as string}>
                  <VpnKeyIcon />
               </Tooltip>
            )
         }
         disabled={isFetching}
      >
         <SubMenuItem name={t('Import Key')}>
            <HeaderMenuItem
               name={t('... as PGP Public Key')}
               disabled={!isSelectedFile}
               onClick={() =>
                  dispatch(
                     action(keyTypes.IMPORT_REMOTE_KEY.SAGA, {
                        transport: getTransportData(),
                        partnerId,
                        filePath: selected,
                        setLoading,
                     })
                  )
               }
            />
            {/* {isAdmin && (
               <HeaderMenuItem
                  name={t('... as PGP Key Pair')}
                  disabled={!isSelectedFile}
                  onClick={() =>
                     dispatch(
                        action(keyTypes.IMPORT_REMOTE_KEY.SAGA, {
                           transport: getTransportData(),
                           partnerId,
                           filePath: selected,
                           secret: true,
                        })
                     )
                  }
               />
            )} */}
            <HeaderMenuItem
               name={t('... as SSH Public Key')}
               disabled={!isSelectedFile}
               onClick={() =>
                  dispatch(
                     action(keyTypes.IMPORT_REMOTE_KEY.SAGA, {
                        transport: getTransportData(),
                        partnerId,
                        filePath: selected,
                        ssh: true,
                        setLoading,
                     })
                  )
               }
            />
            {/* {isAdmin && (
               <HeaderMenuItem
                  name={t('... as SSH Key Pair')}
                  disabled={!isSelectedFile || !isAdmin}
                  onClick={() =>
                     dispatch(
                        action(keyTypes.IMPORT_REMOTE_KEY.SAGA, {
                           transport: getTransportData(),
                           partnerId,
                           filePath: selected,
                           ssh: true,
                           secret: true,
                        })
                     )
                  }
               />
            )} */}
         </SubMenuItem>
         <SubMenuItem name={t('Upload Key')}>
            <HeaderMenuItem
               name={t('...PGP Public Key')}
               onClick={() =>
                  dispatch(
                     action(keyTypes.UPLOAD_REMOTE_KEY.SAGA, {
                        transport: getTransportData(),
                        partnerId,
                        filePath: path,
                        onUpdate,
                        setLoading,
                     })
                  )
               }
            />
            {/* {isAdmin && (
               <HeaderMenuItem
                  name={t('...PGP Key Pair')}
                  onClick={() =>
                     dispatch(
                        action(keyTypes.UPLOAD_REMOTE_KEY.SAGA, {
                           transport: getTransportData(),
                           partnerId,
                           filePath: path,
                           secret: true,
                        })
                     )
                  }
               />
            )} */}
            <HeaderMenuItem
               name={t('...SSH Public Key')}
               onClick={() =>
                  dispatch(
                     action(keyTypes.UPLOAD_REMOTE_KEY.SAGA, {
                        transport: getTransportData(),
                        partnerId,
                        filePath: path,
                        ssh: true,
                        onUpdate,
                        setLoading,
                     })
                  )
               }
            />
            {/* {isAdmin && (
               <HeaderMenuItem
                  name={t('...SSH Key Pair')}
                  onClick={() =>
                     dispatch(
                        action(keyTypes.UPLOAD_REMOTE_KEY.SAGA, {
                           transport: getTransportData(),
                           partnerId,
                           filePath: path,
                           ssh: true,
                           secret: true,
                        })
                     )
                  }
               />
            )} */}
         </SubMenuItem>
      </Menu>
   );
};
